var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",attrs:{"data-clipboard-text":_vm.content}},[(_vm.status === 'success')?_vm._t("success"):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }